"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("@webnuts/type-guard");
var react_1 = require("react");
// eslint-disable-next-line no-restricted-imports
var styled_components_1 = __importStar(require("styled-components"));
var css_types_1 = require("../../internal/css-types");
var box_sizing_1 = require("../../internal/css-types/box-sizing");
var display_1 = require("../../internal/css-types/display");
var position_1 = require("../../internal/css-types/position");
var z_index_1 = require("../../internal/css-types/z-index");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
var SETTINGS = {
    display: type_guard_1.optional(display_1.display),
    flexDirection: type_guard_1.optional(css_types_1.flexDirection),
    flexWrap: type_guard_1.optional(css_types_1.flexWrap),
    justifyContent: type_guard_1.optional(css_types_1.justifyContent),
    alignItems: type_guard_1.optional(css_types_1.alignItems),
    alignContent: type_guard_1.optional(css_types_1.alignItems),
    alignSelf: type_guard_1.optional(css_types_1.alignItems),
    order: type_guard_1.optional(type_guard_1.number()),
    flexGrow: type_guard_1.optional(type_guard_1.number()),
    flexShrink: type_guard_1.optional(type_guard_1.number()),
    flexBasis: type_guard_1.optional(css_types_1.measureUnit),
    height: type_guard_1.optional(css_types_1.height),
    width: type_guard_1.optional(css_types_1.width),
    padding: type_guard_1.optional(css_types_1.padding),
    background: type_guard_1.optional(css_types_1.background),
    border: type_guard_1.optional(css_types_1.border),
    boxShadow: type_guard_1.optional(css_types_1.boxShadow),
    margin: type_guard_1.optional(css_types_1.padding),
    boxSizing: type_guard_1.optional(box_sizing_1.boxSizing),
    position: type_guard_1.optional(position_1.position),
    zIndex: type_guard_1.optional(z_index_1.zIndex)
};
exports.FactoryBox = factory_1.factory({
    prefix: 'Box',
    settings: __assign(__assign({}, SETTINGS), { 
        /**
         * The tagName is not responsive, ie only the tagName set on the global
         * settings is used.
         */
        tagName: type_guard_1.optional(css_types_1.tagName), breakpoints: factory_utils_1.makeBreakpointSettings(SETTINGS) }),
    component: function (settings, utils) {
        var _a;
        var Box = styled_components_1.default((_a = settings.tagName) !== null && _a !== void 0 ? _a : 'div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: flex;\n      box-sizing: border-box;\n\n      ", "\n    "], ["\n      display: flex;\n      box-sizing: border-box;\n\n      ", "\n    "])), function (_a) {
            var $settings = _a.$settings;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (breakpointSettings) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", ";\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.rule('display', breakpointSettings.display), utils.css.rule('flex-direction', breakpointSettings.flexDirection), utils.css.rule('flex-wrap', breakpointSettings.flexWrap), utils.css.rule('justify-content', breakpointSettings.justifyContent), utils.css.rule('align-items', breakpointSettings.alignItems), utils.css.rule('align-content', breakpointSettings.alignContent), utils.css.rule('align-self', breakpointSettings.alignSelf), utils.css.rule('order', breakpointSettings.order), utils.css.rule('flex-grow', breakpointSettings.flexGrow), utils.css.rule('flex-shrink', breakpointSettings.flexShrink), utils.css.rule('flex-basis', breakpointSettings.flexBasis), utils.css.rule('box-sizing', breakpointSettings.boxSizing), utils.css.height(breakpointSettings.height), utils.css.width(breakpointSettings.width), utils.css.padding(breakpointSettings.padding), utils.css.background(breakpointSettings.background), utils.css.border(breakpointSettings.border), utils.css.boxShadow(breakpointSettings.boxShadow), utils.css.margin(breakpointSettings.margin), utils.css.position(breakpointSettings.position), utils.css.rule('z-index', breakpointSettings.zIndex)); });
        });
        return react_1.forwardRef(function (props, ref) { return (jsx_runtime_1.jsx(Box, __assign({ as: undefined, "$settings": settings, ref: ref }, props), void 0)); });
    }
}).FactoryBox;
var templateObject_1, templateObject_2;
